import React, { useCallback, useMemo, useState } from "react";
import { FormLayoutWithEdit } from "../../Form/FormSection";
import RightSideFieldsBar from "../../Form/RightSideFieldsBar";

const AppUserForm = () => {
  const [dragFromOutside, setDragFromOutside] = useState(false);

  const handleDragStart = useCallback(
    (e, name) => {
      e.dataTransfer.setData("type", name);
      setDragFromOutside(true);
    },
    [setDragFromOutside]
  );

  const memoizedRightSideFieldsBar = useMemo(() => {
    return <RightSideFieldsBar from={"appuser"} handleDragStart={handleDragStart} />;
  }, [handleDragStart]);

  return (
    <div className="form_outer_section w_100">
      <FormLayoutWithEdit
        dragFromOutside={dragFromOutside}
        setDragFromOutside={setDragFromOutside}
        isDesktopModeOpen={false}
        from="appuser"
        tableID={"appuser"}
      />
      <div className="rightsidebar">{memoizedRightSideFieldsBar}</div>
    </div>
  );
};

export default AppUserForm;
